<style lang="sass">

    @import ../../common/styles/settings
    @import ../../common/styles/mixins

    .offers-collection
        &__pros
            display: block
            margin-top: $baseline
            position: relative
            padding: $baseline
            background: darken($color-background-light, 5%)
            border-radius: .25rem
            text-align: left
            font-weight: 400
            font-size: 1rem
            color: inherit
            text-decoration: none
            transition: background-color $speed-normal $authentic-motion

            &::after
                +pseudo
                box-shadow: $card-shadow-high
                border-radius: inherit
                opacity: 0
                transition: opacity $speed-normal $authentic-motion

            &::before
                +pseudo((left: 90%, top: 50%, height: 1em, width: 1em))
                content: url(../../common/assets/icon-chevron-right--blue.svg)
                margin-top: -.5em
                backface-visibility: hidden
                transition: transform $speed-fast $authentic-motion

            &:hover
                background: $color-background-light

                &::after
                    opacity: .35
                &::before
                    transform: translateX(.5rem)

            strong
                display: block
                font-weight: 400
                text-transform: uppercase


</style>

<script>
export default {}
</script>
